module.exports = __webpack_public_path__ + "img/8.333030e5.png";